import { Outlet } from "@tanstack/react-router";

export function ReportScreen() {
  return <Outlet />;
}
